/* eslint-disable dot-notation */

export function registerEventGenerators(gen) {
  gen.forBlock['event_when_start'] = function (block, generator) {
    const branch = generator.statementToCode(block, 'DO') || ''
    return `onStart(async () => {\n${branch}});\n`
  }

  gen.forBlock['event_when_sprite_clicked'] = function (block, generator) {
    const sprite = block.getFieldValue('SPRITE') || 'kiko'
    const branch = generator.statementToCode(block, 'DO') || ''
    return `onSpriteTap('${sprite}', async () => {\n${branch}});\n`
  }

  gen.forBlock['event_when_collide'] = function (block, generator) {
    const spriteA = block.getFieldValue('SPRITE_A') || 'kiko'
    const spriteB = block.getFieldValue('SPRITE_B') || 'batu'
    const branch = generator.statementToCode(block, 'DO') || ''
    return `onCollide('${spriteA}', '${spriteB}', async () => {\n${branch}});\n`
  }

  gen.forBlock['event_when_key'] = function (block, generator) {
    const key = block.getFieldValue('KEY') || 'Space'
    const branch = generator.statementToCode(block, 'DO') || ''
    return `onKey('${key}', async () => {\n${branch}});\n`
  }

  gen.forBlock['event_every_n_seconds'] = function (block, generator) {
    const seconds = block.getFieldValue('SECONDS') || 1
    const branch = generator.statementToCode(block, 'DO') || ''
    return `onInterval(${seconds}, async () => {\n${branch}});\n`
  }
}
